import { z } from "zod";

export const refsSchema = z.record(z.union([z.number(), z.array(z.number()), z.undefined()]));

export type NodeReferences = z.infer<typeof refsSchema>;
